// =============================================================================
// src/views/workspace/workspace-sections.ts — Seções-destino de uma análise.
//
// As 8 seções scrolláveis às quais "Abrir análise" pode navegar (exclui grafo e
//   cinema, que são layers/rotas, não seções de scroll). Fonte única usada tanto
//   pelo store (rótulo do `meta` da análise criada) quanto pelo <select> do modal
//   "Nova análise" — DRY.
//
// SRP: só o catálogo de seções-destino + lookup de rótulo.
// =============================================================================

import type { SectionId } from '../../app/types';

/** Par {id, rótulo} de uma seção-destino navegável. */
export interface WorkspaceSectionOption {
  readonly id: SectionId;
  readonly label: string;
}

/** As 8 seções scrolláveis, na ordem do #contentCol. */
export const WORKSPACE_SECTION_OPTIONS: readonly WorkspaceSectionOption[] = [
  { id: 'mapa-eleitoral', label: 'Mapa Eleitoral' },
  { id: 'perfil-regiao', label: 'Perfil da Região' },
  { id: 'comparador', label: 'Comparador' },
  { id: 'demografica', label: 'Demografia' },
  { id: 'camadas', label: 'Estúdio de Camadas' },
  { id: 'negocios', label: 'Negócios' },
  { id: 'impostometro', label: 'Impostômetro' },
  { id: 'monitoramento', label: 'Monitoramento' },
];

/** Rótulo de exibição de uma seção; devolve o próprio id se não for navegável. */
export function sectionLabelOf(id: SectionId): string {
  const option = WORKSPACE_SECTION_OPTIONS.find((opt) => opt.id === id);
  return option ? option.label : id;
}
